<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :class="disabled ? 'dialog-text settings-text disabled' : 'dialog-text settings-text'"
        dense
        filled
        hide-details
        append-icon="mdi-calendar-month-outline"
        v-model="computedDate"
        v-bind="attrs"
        v-on="on"
        :disabled="disabled"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="computedDate"
      no-title
      scrollable
      @input="menu = false"
    >
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
      <v-btn text color="primary" @click="$refs.menu.save(computedDate)"
        >OK</v-btn
      >
    </v-date-picker>
  </v-menu>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "DatePicker",
  props: {
    date: String,
    disabled: Boolean
  },
  data: () => ({
    menu: false,
    selectedDate: 0
  }),
  created() {
    this.selectedDate = this.date;
  },
  computed: {
    computedDate: {
      // getter
      get: function() {
        return this.selectedDate;
      },
      // setter
      set: function(newValue) {
        this.selectedDate = newValue;
      }
    }
  },
  watch: {
    date: function(val) {
      this.selectedDate = val;
    },
    computedDate: function(val) {
      this.$emit("dateSelected", val);
    }
  }
});
</script>
